export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-14 md:py-20" data-testid="about-page">
      <div className="overline">About</div>
      <h1 className="font-display text-4xl text-teal-900 mt-2">Surf recommendations, not spreadsheets.</h1>
      <p className="mt-5 text-teal-900 leading-relaxed">
        Surfmatics helps beginner and intermediate surfers answer one practical question: where and
        when should I surf, given my ability, location and time available?
      </p>
      <p className="mt-4 text-muted-foreground leading-relaxed">
        We combine live marine and weather forecasts (Open-Meteo, behind an internal adapter) with
        curated surf-area metadata and live community reports. A rule-based recommendation engine
        turns those inputs into a personal suitability score, a plain-English summary and a
        confidence rating. Hard safety exclusions can never be overridden by commercial factors.
      </p>
      <h2 className="mt-10 font-display text-2xl text-teal-900">Design principles</h2>
      <ul className="mt-3 space-y-2 text-teal-900">
        <li>· Personal suitability, not raw wave quality.</li>
        <li>· Safety always overrides opportunity.</li>
        <li>· Confidence is communicated, never hidden.</li>
        <li>· Business placement is kept separate from the recommendation score.</li>
        <li>· Auditable, versioned scoring — every recommendation stores its inputs.</li>
      </ul>
    </div>
  );
}
